enum FontFamilyPairSlug {
    Brandon = 'brandon',
    Freeland = 'freeland',
    Baskerville = 'baskerville',
    Blooming = 'blooming-elegant',
    BambusaPro = 'bambusa-pro-regular',
    SBOne = 'scandiebox-one',
    // Google Fonts
    Roboto = 'roboto',
    Lato = 'lato',
    Spectral = 'spectral',
    Montserrat = 'montserrat',
    Oswald = 'oswald',
    Quicksand = 'quicksand',
    Raleway = 'raleway',
    Inter = 'inter',
    Playfair = 'playfair',
    PtSans = 'pt-sans',
    RedHatDisplay = 'red-hat-display',
    Merriweather = 'merriweather',
    Figtree = 'figtree',
    Palanquin = 'palanquin',
    Slabo27px = 'slabo-27px',
    Sora = 'sora',
    Cabin = 'cabin',
    CormorantGaramond = 'cormorant-garamond',
    Caveat = 'caveat',
    ShadowsIntoLight = 'shadows-into-light',
    ReenieBeanie = 'reenie-beanie',
    BilboSwashCaps = 'bilbo-swash-caps',
    IndieFlower = 'indie-flower',
    DancingScript = 'dancing-script',
    Urbanist = 'urbanist',
    BarlowSemiCondensed = 'barlow-semi-condensed',
    BebasNeue = 'bebas-neue',
    Lora = 'lora'
}

const fontFamilyPairs = {
    [FontFamilyPairSlug.Brandon]: {
        primaryFontFamilies: ['Brandon', 'Arial', 'Helvetica', 'sans-serif'],
        secondaryFontFamilies: ['Brandon', 'Arial', 'Helvetica', 'sans-serif']
    },
    [FontFamilyPairSlug.Freeland]: {
        primaryFontFamilies: ['ProximaNova', 'ProximaNova-Regular', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['Freeland', 'Arial Bold', 'sans-serif']
    },
    [FontFamilyPairSlug.Baskerville]: {
        primaryFontFamilies: [
            'Baskerville',
            'Baskerville Old Face',
            'Goudy Old Style',
            'Garamond',
            'Times New Roman',
            'Serif'
        ],
        secondaryFontFamilies: ['open-sans', 'Tahoma', 'sans-serif']
    },
    [FontFamilyPairSlug.Blooming]: {
        primaryFontFamilies: ['open-sans', 'Tahoma', 'sans-serif'],
        secondaryFontFamilies: ['blooming-elegant', 'Times New Roman', 'Serif']
    },
    [FontFamilyPairSlug.BambusaPro]: {
        primaryFontFamilies: ['open-sans', 'Tahoma', 'sans-serif'],
        secondaryFontFamilies: ['bambusa-pro-regular', 'Times New Roman', 'Serif']
    },
    [FontFamilyPairSlug.SBOne]: {
        primaryFontFamilies: ['open-sans', 'Arial Bold', 'sans-serif'],
        secondaryFontFamilies: ['scandiebox-one', 'Times New Roman', 'serif']
    },
    // Google Fonts
    [FontFamilyPairSlug.Roboto]: {
        primaryFontFamilies: ['"Roboto"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Roboto"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Lato]: {
        primaryFontFamilies: ['"Lato"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Lato"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Spectral]: {
        primaryFontFamilies: ['"Spectral"', 'Georgia', 'serif'],
        secondaryFontFamilies: ['"Spectral"', 'Georgia', 'serif']
    },
    [FontFamilyPairSlug.Montserrat]: {
        primaryFontFamilies: ['"Montserrat"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Montserrat"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Oswald]: {
        primaryFontFamilies: ['"Oswald"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Oswald"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Quicksand]: {
        primaryFontFamilies: ['"Quicksand"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Quicksand"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Raleway]: {
        primaryFontFamilies: ['"Raleway"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Raleway"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Inter]: {
        primaryFontFamilies: ['"Inter"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Inter"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Playfair]: {
        primaryFontFamilies: ['"Playfair Display"', 'Georgia', 'serif'],
        secondaryFontFamilies: ['"Playfair Display"', 'Georgia', 'serif']
    },
    [FontFamilyPairSlug.PtSans]: {
        primaryFontFamilies: ['"PT Sans"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"PT Sans"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.RedHatDisplay]: {
        primaryFontFamilies: ['"Red Hat Display"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Red Hat Display"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Merriweather]: {
        primaryFontFamilies: ['"Merriweather"', 'Georgia', 'serif'],
        secondaryFontFamilies: ['"Merriweather"', 'Georgia', 'serif']
    },
    [FontFamilyPairSlug.Figtree]: {
        primaryFontFamilies: ['"Figtree"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Figtree"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Palanquin]: {
        primaryFontFamilies: ['"Palanquin"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Palanquin"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Slabo27px]: {
        primaryFontFamilies: ['"Slabo 27px"', 'Georgia', 'serif'],
        secondaryFontFamilies: ['"Slabo 27px"', 'Georgia', 'serif']
    },
    [FontFamilyPairSlug.Sora]: {
        primaryFontFamilies: ['"Sora"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Sora"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Cabin]: {
        primaryFontFamilies: ['"Cabin"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Cabin"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.CormorantGaramond]: {
        primaryFontFamilies: ['"Cormorant Garamond"', 'Georgia', 'serif'],
        secondaryFontFamilies: ['"Cormorant Garamond"', 'Georgia', 'serif']
    },
    [FontFamilyPairSlug.Caveat]: {
        primaryFontFamilies: ['"Caveat"', 'cursive'],
        secondaryFontFamilies: ['"Caveat"', 'cursive']
    },
    [FontFamilyPairSlug.ShadowsIntoLight]: {
        primaryFontFamilies: ['"Shadows Into Light"', 'cursive'],
        secondaryFontFamilies: ['"Shadows Into Light"', 'cursive']
    },
    [FontFamilyPairSlug.ReenieBeanie]: {
        primaryFontFamilies: ['"Reenie Beanie"', 'cursive'],
        secondaryFontFamilies: ['"Reenie Beanie"', 'cursive']
    },
    [FontFamilyPairSlug.BilboSwashCaps]: {
        primaryFontFamilies: ['"Bilbo Swash Caps"', 'cursive'],
        secondaryFontFamilies: ['"Bilbo Swash Caps"', 'cursive']
    },
    [FontFamilyPairSlug.IndieFlower]: {
        primaryFontFamilies: ['"Indie Flower"', 'cursive'],
        secondaryFontFamilies: ['"Indie Flower"', 'cursive']
    },
    [FontFamilyPairSlug.DancingScript]: {
        primaryFontFamilies: ['"Dancing Script"', 'cursive'],
        secondaryFontFamilies: ['"Dancing Script"', 'cursive']
    },
    [FontFamilyPairSlug.Urbanist]: {
        primaryFontFamilies: ['"Urbanist"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Urbanist"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.BarlowSemiCondensed]: {
        primaryFontFamilies: ['"Barlow Semi Condensed"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Barlow Semi Condensed"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.BebasNeue]: {
        primaryFontFamilies: ['"Bebas Neue"', 'Arial', 'sans-serif'],
        secondaryFontFamilies: ['"Bebas Neue"', 'Arial', 'sans-serif']
    },
    [FontFamilyPairSlug.Lora]: {
        primaryFontFamilies: ['"Lora"', 'Georgia', 'serif'],
        secondaryFontFamilies: ['"Lora"', 'Georgia', 'serif']
    }
};

function joinFontFamilies(fontFamilies: string[]) {
    return fontFamilies.join(', ');
}

/**
 * A ShootProof-curated pair of font families for gallery theming
 */
export interface IFontFamilyPair {
    primaryFontFamily: string;
    secondaryFontFamily: string;
}

/**
 * Choose a FontFamilyPair via its font set slug
 */
export function getFontFamilyPair(fontSlug: string): IFontFamilyPair {
    const fontPair = fontFamilyPairs[fontSlug];
    const primaryFontFamily = joinFontFamilies(fontPair.primaryFontFamilies);
    const secondaryFontFamily = joinFontFamilies(fontPair.secondaryFontFamilies);

    return { primaryFontFamily, secondaryFontFamily };
}

/**
 * Get display name for a font slug from the FONT_OPTIONS array
 */
export function getFontDisplayName(fontSlug: SpApi.FontSet): string | undefined {
    const fontOption = FONT_OPTIONS.find((option) => option.value === fontSlug);
    return fontOption?.label;
}

// Font options for UI display
export interface IFontOption {
    label: string;
    value: SpApi.FontSet;
}

export const FONT_OPTIONS: IFontOption[] = [
    { label: 'Brandon', value: 'brandon' },
    { label: 'Freeland', value: 'freeland' },
    { label: 'Baskerville', value: 'baskerville' },
    { label: 'Blooming Elegant', value: 'blooming-elegant' },
    { label: 'Bambusa Pro Regular', value: 'bambusa-pro-regular' },
    { label: 'Scandiebox One', value: 'scandiebox-one' },
    // Google Fonts
    { label: 'Roboto', value: 'roboto' },
    { label: 'Lato', value: 'lato' },
    { label: 'Spectral', value: 'spectral' },
    { label: 'Montserrat', value: 'montserrat' },
    { label: 'Oswald', value: 'oswald' },
    { label: 'Quicksand', value: 'quicksand' },
    { label: 'Raleway', value: 'raleway' },
    { label: 'Inter', value: 'inter' },
    { label: 'Playfair', value: 'playfair' },
    { label: 'PT Sans', value: 'pt-sans' },
    { label: 'Red Hat Display', value: 'red-hat-display' },
    { label: 'Merriweather', value: 'merriweather' },
    { label: 'Figtree', value: 'figtree' },
    { label: 'Palanquin', value: 'palanquin' },
    { label: 'Slabo 27px', value: 'slabo-27px' },
    { label: 'Sora', value: 'sora' },
    { label: 'Cabin', value: 'cabin' },
    { label: 'Cormorant Garamond', value: 'cormorant-garamond' },
    { label: 'Urbanist', value: 'urbanist' },
    { label: 'Barlow Semi Condensed', value: 'barlow-semi-condensed' },
    { label: 'Bebas Neue', value: 'bebas-neue' },
    { label: 'Lora', value: 'lora' },
    { label: 'Caveat', value: 'caveat' },
    { label: 'Shadows Into Light', value: 'shadows-into-light' },
    { label: 'Reenie Beanie', value: 'reenie-beanie' },
    { label: 'Bilbo Swash Caps', value: 'bilbo-swash-caps' },
    { label: 'Indie Flower', value: 'indie-flower' },
    { label: 'Dancing Script', value: 'dancing-script' }
];

// CSS font family mappings for display purposes
const googleFontFamilies: Record<string, string> = {
    roboto: 'Roboto, sans-serif',
    lato: 'Lato, sans-serif',
    spectral: 'Spectral, serif',
    montserrat: 'Montserrat, sans-serif',
    oswald: 'Oswald, sans-serif',
    quicksand: 'Quicksand, sans-serif',
    raleway: 'Raleway, sans-serif',
    inter: 'Inter, sans-serif',
    playfair: '"Playfair Display", serif',
    'pt-sans': '"PT Sans", sans-serif',
    'red-hat-display': '"Red Hat Display", sans-serif',
    merriweather: 'Merriweather, serif',
    figtree: 'Figtree, sans-serif',
    palanquin: 'Palanquin, sans-serif',
    'slabo-27px': '"Slabo 27px", serif',
    sora: 'Sora, sans-serif',
    cabin: 'Cabin, sans-serif',
    'cormorant-garamond': '"Cormorant Garamond", serif',
    caveat: 'Caveat, cursive',
    'shadows-into-light': '"Shadows Into Light", cursive',
    'reenie-beanie': '"Reenie Beanie", cursive',
    'bilbo-swash-caps': '"Bilbo Swash Caps", cursive',
    'indie-flower': '"Indie Flower", cursive',
    'dancing-script': '"Dancing Script", cursive',
    urbanist: 'Urbanist, sans-serif',
    'barlow-semi-condensed': '"Barlow Semi Condensed", sans-serif',
    'bebas-neue': '"Bebas Neue", sans-serif',
    lora: 'Lora, serif'
};

export const isCursiveFont = (font: SpApi.FontSet) =>
    [
        // Original cursive fonts
        'bambusa-pro-regular',
        'blooming-elegant',
        'freeland',
        'scandiebox-one',
        // New Google cursive/script fonts
        'caveat',
        'shadows-into-light',
        'reenie-beanie',
        'bilbo-swash-caps',
        'indie-flower',
        'dancing-script',
        'playfair'
    ].includes(font);

/**
 * Get CSS font family for a given font slug
 */
export function getFontFamilyFromFontSlug(fontSlug: SpApi.FontSet): string {
    return googleFontFamilies[fontSlug] || fontSlug;
}

/**
 * Get font size for consistent display in UI
 */
export function getFontSize(fontValue: SpApi.FontSet): string {
    switch (fontValue) {
        case 'blooming-elegant':
        case 'bilbo-swash-caps':
            return '24px'; // Make it larger since it appears small
        case 'scandiebox-one':
        case 'caveat':
        case 'dancing-script':
            return '20px'; // Make it larger since it appears small
        case 'bambusa-pro-regular':
        case 'oswald':
            return '14px'; // Make it smaller since it appears large
        case 'shadows-into-light':
        case 'reenie-beanie':
        case 'indie-flower':
            return '18px'; // Medium size for handwritten fonts
        default:
            return '16px'; // Standard size for most fonts
    }
}

/**
 * Get baseline adjustment for vertical alignment
 */
export function getBaselineAdjustment(fontValue: SpApi.FontSet): string {
    switch (fontValue) {
        case 'scandiebox-one':
        case 'oswald':
            return 'translateY(4px)'; // Push down slightly to align with other fonts
        case 'dancing-script':
        case 'shadows-into-light':
            return 'translateY(2px)'; // Slight adjustment for script fonts
        default:
            return 'translateY(0px)';
    }
}

/**
 * Get text styling properties for a font (without fontFamily)
 */
export function getFontStylingFromFontSlug(fontSlug: SpApi.FontSet) {
    const isNotCursive = !isCursiveFont(fontSlug);
    const fontWeight = fontSlug === 'brandon' ? 'bold' : 'normal';

    return {
        textTransform: isNotCursive ? ('uppercase' as const) : ('none' as const),
        letterSpacing: isNotCursive ? '5%' : 'normal',
        fontWeight,
        fontSize: getFontSize(fontSlug),
        transform: getBaselineAdjustment(fontSlug)
    };
}
